import { render, staticRenderFns } from "./yearlyFxRatesTable.vue?vue&type=template&id=681d73f3"
import script from "./yearlyFxRatesTable.vue?vue&type=script&lang=js"
export * from "./yearlyFxRatesTable.vue?vue&type=script&lang=js"
import style0 from "./yearlyFxRatesTable.vue?vue&type=style&index=0&id=681d73f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports